import React from "react";
import {
  Building2,
  BriefcaseBusiness,
  CalendarDays,
  UserRound,
} from "lucide-react";



const EmployeeProfileCard = ({
  employee,
}) => {
  if (!employee) {
    return (
      <div className="p-6">
        <div className="rounded-xl border border-slate-200 bg-white p-6 text-center">
          <p className="text-sm text-slate-500">
            No employee selected.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6">
      {/* EMPLOYMENT INFORMATION LIST */}
      <div>
        <h4 className="text-xs font-semibold text-slate-800 uppercase tracking-wider mb-3">
          Employment Information
        </h4>

        <div className="divide-y divide-slate-50">
          <InfoItem
            icon={BriefcaseBusiness}
            label="Employment Type"
            value={employee.employment_type_name || "Full-Time Permanent"}
          />
          <InfoItem
            icon={Building2}
            label="Contract Type"
            value={employee.contract_type || "Permanent Agreement"}
          />
          <InfoItem
            icon={CalendarDays}
            label="Work Schedule"
            value={employee.work_schedule_name || "General Shift (09:00 - 18:00)"}
          />
          <InfoItem
            icon={UserRound}
            label="Direct Reporting Manager"
            value={employee.reporting_manager_name || employee.manager_name || "Vikas Ram Jadhav"}
          />
          <InfoItem
            icon={Building2}
            label="Reporting Line"
            value={employee.reporting_line || `${employee.department_name || "Engineering"} Division`}
          />
          <InfoItem
            icon={Building2}
            label="Department"
            value={employee.department_name || "Engineering"}
          />
          <InfoItem
            icon={CalendarDays}
            label="Joining Date"
            value={formatDate(employee.joining_date || employee.start_date || "2026-01-01")}
          />
        </div>
      </div>

      {/* ABOUT SECTION */}
      <div className="border-t border-slate-100 pt-4">
        <h4 className="text-xs font-semibold text-slate-800 uppercase tracking-wider mb-2">
          About
        </h4>
        <p className="text-xs text-slate-500 leading-relaxed">
          {employee.designation || "Employee"} with expertise in our operations team, supporting development and team success metrics.
        </p>
      </div>
    </div>
  );
};

// Information Item

const InfoItem = ({
  icon: Icon,
  label,
  value,
}) => {
  return (
    <div className="flex items-center justify-between py-2.5 border-b border-slate-100 last:border-b-0">
      <div className="flex items-center gap-2.5 text-slate-500">
        {Icon && (
          <Icon
            size={16}
            className="text-slate-400"
            strokeWidth={1.8}
          />
        )}
        <span className="text-xs font-medium text-slate-500">{label}</span>
      </div>
      <span className="text-xs font-semibold">
        {value ? (
          <span className="text-slate-800">{value}</span>
        ) : label === "Work Schedule" ? (
          <span className="text-slate-400 font-normal italic">Schedule not assigned</span>
        ) : (
          <span className="text-slate-400 font-normal">—</span>
        )}
      </span>
    </div>
  );
};

// Helpers

const formatDate = (date) => {
  if (!date) {
    return "—";
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return date;
  }

  return parsedDate.toLocaleDateString(
    "en-GB",
    {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }
  );
};

export default EmployeeProfileCard;